
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import TableListSort from 'core/TableListSort';


export default class PointListTable extends Component {
  render() {
    const { items, onDetail } = this.props;
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" className={'hide-on-mobile'}>
              <TableListSort label={'#'} name={'id'} />
            </TableCell>
            <TableCell component="th" scope="row">
              <TableListSort label={'Название'} name={'name'} />
            </TableCell>
            <TableCell component="th" scope="row">
              <TableListSort label={'Адрес'} name={'address'} />
            </TableCell>
            <TableCell component="th" scope="row">
              Контакты
            </TableCell>
            <TableCell component="th" scope="row">
              <TableListSort label={'Отстояние, км'} name={'distance'} />
            </TableCell>
            <TableCell component="th" scope="row">
              Услуг
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(item =>
          <TableRow
            key={item.id}
            hover={true}
            className={'pointer'}
            onClick={(event) => onDetail(item)}
          >
            <TableCell className={'hide-on-mobile'}>{item.id}</TableCell>
            <TableCell>{item.name}</TableCell>
            <TableCell style={{wordBreak: 'break-word'}}>{item.address}</TableCell>
            <TableCell>{item.contact}</TableCell>
            <TableCell>{item.distance}</TableCell>
            <TableCell>{item.services.length}</TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
